<section class="form_section">
    <div class="dialog-header">
      <button mat-icon-button (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2>Cantidad de Facturas</h2>
    <form action="" [formGroup]="formRegisterCantidad" (ngSubmit)="submit()" class="form_register_minutes">
      <mat-form-field class="example-form-field">
        <mat-label>Cantidad</mat-label>
        <input matInput formControlName="cantidad"/>
      </mat-form-field>
      <button mat-stroked-button color="primary" class="w-50" [disabled]="!formRegisterCantidad.valid" *ngIf="!booleanFlag">
        Guardar
      </button>
    </form>
  </section>